import { useEffect, useRef, useState } from 'react';
import { requestEmailVerificationPublic } from '../../api/auth';

export function ResendVerification({ initialEmail = '' }) {
  const [email, setEmail] = useState(initialEmail);
  const [busy, setBusy] = useState(false);
  const [remaining, setRemaining] = useState(0);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const sending = useRef(false);

  useEffect(() => {
    if (!remaining) return undefined;
    const timer = setTimeout(() => setRemaining(value => Math.max(0, value - 1)), 1000);
    return () => clearTimeout(timer);
  }, [remaining]);

  const handleSubmit = async event => {
    event.preventDefault();
    if (sending.current || remaining) return;
    sending.current = true;
    setBusy(true);
    setError('');
    setMessage('');
    try {
      const result = await requestEmailVerificationPublic(email.trim());
      setMessage(result?.detail || 'Если для этой почты требуется подтверждение, мы отправили письмо.');
      setRemaining(60);
    } catch (err) {
      setError(err?.message || 'Не удалось отправить письмо. Попробуйте позже.');
    } finally {
      sending.current = false;
      setBusy(false);
    }
  };

  return (
    <form className="auth-form auth-resend" onSubmit={handleSubmit}>
      <label className="form-group" htmlFor="verification-email">
        <span className="form-label">Почта, указанная при регистрации</span>
        <input id="verification-email" className="form-input" type="email" autoComplete="email"
          required value={email} onChange={event => setEmail(event.target.value)} placeholder="you@example.com" />
      </label>
      <button className="auth-button" type="submit" disabled={busy || remaining > 0}>
        {busy ? 'Отправляем…' : remaining ? `Повторить через ${remaining} с` : 'Отправить письмо подтверждения'}
      </button>
      {message && <p className="auth-link auth-link-success" role="status">{message}</p>}
      {error && <p className="auth-link auth-link-error" role="alert">{error}</p>}
      <p className="auth-support-note">
        Письмо может идти несколько минут. Проверьте «Спам» и правильность адреса.
        Если письмо не приходит, напишите на <a href="mailto:sfedupro@yandex.com">sfedupro@yandex.com</a>.
      </p>
    </form>
  );
}
